import { useEffect } from "react";
import { Userpilot } from "userpilot";
import { getAPICall } from "lib/callApi";
import { useSelector } from "react-redux";
import {
  USER_ROLES,
  GET_SINGLE_COMPANY,
  FETCH_ALL_KPI_TEMPLATES,
  PERMISSIONS_NAME,
} from "lib/constants";

Userpilot.initialize(process.env.REACT_APP_USERPILOT_KEY);

const useUserPilot = (user, subscription) => {
  const isProxyLogin = useSelector((state) => state.loginUser.isProxyLogin);
  useEffect(() => {
    try {
      if (user?.id && user.companyId && process.env.REACT_APP_APP_ENVIRONMENT && !isProxyLogin) {
        const fetchUserPilotData = async () => {
          const identificationData = {
            name: user.name,
            email: user.email,
            created_at: user.companyJoinDate,
            company: {
              id: `${process.env.REACT_APP_APP_ENVIRONMENT}:${user.companyId}`,
            },
          };

          const userPermissionKeys = Object.keys(user?.userPermission || {});
          const admin = user?.userPermission?.[PERMISSIONS_NAME.ADMIN];
          userPermissionKeys.forEach((userPermissionKey) => {
            if (userPermissionKey === PERMISSIONS_NAME.INPUT_KPIS) {
              identificationData[`permission_${userPermissionKey}`] =
                user.userPermission[userPermissionKey];
            } else {
              identificationData[`permission_${userPermissionKey}`] =
                admin || user.userPermission[userPermissionKey];
            }
          });

          if (user.companyId) {
            const [companyDetails, kpiTemplates] = await Promise.all([
              getAPICall(GET_SINGLE_COMPANY + user.companyId, true),
              getAPICall(FETCH_ALL_KPI_TEMPLATES, true, {
                filter: {
                  status: "active",
                  search: "",
                  pageSize: 1,
                  pageNumber: 0,
                },
              }),
            ]);

            identificationData.company.name = companyDetails?.data?.data?.name || "";
            identificationData.companyName = companyDetails?.data?.data?.name || "";
            identificationData.company.created_at = companyDetails?.data?.data?.createdAt || "";
            identificationData.company_has_active_templates = !!kpiTemplates?.data?.data?.count;
          }

          if (subscription && Object.prototype.hasOwnProperty.call(subscription, "isOnFreeTrial"))
            identificationData.company.isOnFreeTrial = subscription.isOnFreeTrial;

          if (subscription && Object.prototype.hasOwnProperty.call(subscription, "openSeatCount"))
            identificationData.company.openSeatCount = subscription.openSeatCount;

          if (subscription && Object.prototype.hasOwnProperty.call(subscription, "seatCount"))
            identificationData.company.seatCount = subscription.seatCount;

          if (subscription && Object.prototype.hasOwnProperty.call(subscription, "activeSeatCount"))
            identificationData.company.totalActiveSeatCount = subscription.activeSeatCount;

          if (
            subscription &&
            Object.prototype.hasOwnProperty.call(subscription, "subscriptionPlanType")
          )
            identificationData.company.subscriptionPlanType = subscription.subscriptionPlanType;

          if (user.roleId) {
            const response = await getAPICall(USER_ROLES, true);
            const allCompanyRoles = response?.data?.data || [];
            const foundRole = allCompanyRoles.find((role) => role.id === user.roleId);

            if (foundRole?.role) {
              identificationData.user_role = foundRole.role;
            }
          }

          Userpilot.identify(
            `${process.env.REACT_APP_APP_ENVIRONMENT}:${user.id}`,
            identificationData
          );
        };

        fetchUserPilotData();
      }
    } catch (err) {
      // user pilot catching should be a side effect not a reason to crash the app or display error
      console.error(err);
    }
  }, [user, subscription, isProxyLogin]);

  return Userpilot;
};

export default useUserPilot;
